import * as React from "react";
import { StyleSheet } from "react-native";
import { useTheme } from "react-native-paper";
import QRCode from "react-native-qrcode-svg";

interface OnlyQRProps {
  value: string;
  size?: number;
}

const OnlyQR = (props: OnlyQRProps) => {
  const { value, size = 100 } = props;
  const { colors } = useTheme();
  return <QRCode size={size} value={value} logoBorderRadius={0} logoBackgroundColor={colors.backgroundForm} ecl="Q" quietZone={5} />;
};

export default OnlyQR;

const styles = StyleSheet.create({
  container: {},
});
